import { useDispatch, useSelector } from "react-redux";

import { updateStatus } from "../redux/filters/actions";

const BookType = () => {
  const dispatch = useDispatch();
  const active = useSelector((state) => state.filters.status);
  const operation = useSelector((state) => state.books.operation);

  const changeStatusHandler = (status) => { dispatch(updateStatus(status)); };

  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>
      <div className="flex items-center space-x-4">
        <button
          id="lws-filterAll"
          disabled={operation === "update" && active !== "showAll"}
          className={`filter-btn ${active === "showAll" && "active-filter"}`}
          onClick={() => changeStatusHandler("showAll")}
        >
          All
        </button>
        <button
          id="lws-filterFeatured"
          disabled={operation === "update" && active !== "featured"}
          className={`filter-btn ${active === "featured" && "active-filter"}`}
          onClick={() => changeStatusHandler("featured")}
        >
          Featured
        </button>
      </div>
    </div>
  );
};

export default BookType;
